var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tab-header"},[_c('Row',{attrs:{"onselectstart":"return false"}},[_c('Col',{attrs:{"span":"20"}},[_vm._v("\n\t\t\t\t并发症记录\n\t\t\t")])],1)],1),_c('Table',{staticStyle:{"width":"100%"},attrs:{"loading":_vm.loading,"columns":_vm.columns,"no-data-text":_vm.L('NoDatas'),"border":"","data":_vm.tableData}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f114b5a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/cancelRecords/index.vue
// module id = null
// module chunks = 